module.exports = __webpack_public_path__ + "static/images/blue-lock.80d3334e6e7a9824fc92772170f66269.svg";